import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import textContent from 'react-addons-text-content';

// app modules: components
import AppStoreLogos from 'components/AppStoreLogos';
import Button from 'components/Button';
import MembershipRenewal from 'components/MembershipRenewal';
import Heading from 'components/Heading';
import MembershipBenefits from 'components/MembershipBenefits';

// app modules: actions
import { openModal } from 'actions/modals';

// app modules: services
import { isApp } from 'services/environment';
import history from 'services/history';

// app modules: constants
import { MODALS } from 'constants/view';

// app: assets
import CssInlinePaywall from './InlinePaywall.scss';

import DualColumnPaywallContent from './DualColumnPaywallContent';

function JoinPaywallContent(props) {
  const { goal } = props;
  useStyles(CssInlinePaywall);
  const dispatch = useDispatch();
  const isRecipePage = useSelector(state => state.router.pathname.startsWith('/recipe'));
  const returnTo = useSelector(state => props.returnTo || state.router.locationState?.returnTo);
  const defaultSubscriptionPlanChoice = useSelector(
    state => state.config.paywall.defaultSubscriptionPlanChoice,
  );
  const returnToFromQueryString = useSelector(
    state =>
      state.router.queryParams?.returnTo ? { pathname: state.router.queryParams.returnTo } : null,
  );
  const recipeOrPage = isRecipePage ? 'recipe' : 'page';
  let { heading } = props;
  if (!heading) {
    heading =
      defaultSubscriptionPlanChoice === 'annual'
        ? `Become a Premium Member to access this ${recipeOrPage}`
        : `Try ckbk for free to access this ${recipeOrPage}`;
  }

  if (goal === 'free') {
    const handleSubscribeButtonClick = () => {
      if (isApp()) {
        import('components/InAppPaymentInfo/InAppPaymentInfo.jsx' /* webpackChunkName: "in-app-payment", webpackMode: "lazy" */).then(
          module => {
            dispatch(
              openModal({
                name: MODALS.IN_APP_PAYMENT,
                content: module.default,
              }),
            );
          },
        );
      } else {
        history.push('/signup');
      }
    };
    return (
      <div>
        <header>
          <Heading id="paywall-heading" level={2} className="heading--size-32 margin-left-10">
            {heading}
          </Heading>
        </header>
        <DualColumnPaywallContent even withWrap>
          <MembershipBenefits
            className="inline-paywall__benefits"
            itemClassName="margin-bottom-5"
          />
          <Button
            size="extra-large"
            themeName="energized"
            className="margin-top-10 margin-bottom-10 margin-left-20 margin-right-20"
            onClick={handleSubscribeButtonClick}
          >
            Get Started
          </Button>
          <div className="inline-paywall__wrapping-row">
            <p className="inline-paywall__login">
              Already a member?{' '}
              <button
                onClick={() => history.push('/login', { returnTo: history.location })}
                className="link link--energized"
              >
                Log in
              </button>
            </p>
            {isApp() ? null : <AppStoreLogos height={40} />}
          </div>
        </DualColumnPaywallContent>
      </div>
    );
  }
  const headingTag = (
    <header>
      <Heading level={2} className="heading--size-32 margin-left-10">
        {heading}
      </Heading>
    </header>
  );
  const headingTextLength =
    typeof heading === 'string' ? heading.length : textContent(headingTag)?.length;
  return (
    <div>
      {headingTextLength > 41 ? headingTag : null}
      <div className="inline-paywall__columns">
        <div className="inline-paywall__col">
          {!heading || headingTextLength <= 41 ? headingTag : null}
          <MembershipBenefits
            premium
            className="inline-paywall__benefits"
            itemClassName="margin-bottom-5"
          />
          <div className="inline-paywall__wrapping-row">
            <p className="inline-paywall__login">
              Already a member?{' '}
              <button
                onClick={() => history.push('/login', { returnTo: history.location })}
                className="link link--energized"
              >
                Log in
              </button>
            </p>
            {isApp() ? null : <AppStoreLogos height={40} />}
          </div>
        </div>
        <div className="inline-paywall__col">
          <MembershipRenewal
            withInlineCheckout={false}
            returnTo={returnToFromQueryString || returnTo || history.location}
            title={null}
          />
        </div>
      </div>
    </div>
  );
}

JoinPaywallContent.propTypes = {
  goal: PropTypes.oneOf(['free', 'premium']),
  heading: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  returnTo: PropTypes.object,
};

JoinPaywallContent.defaultProps = {
  goal: 'premium',
  heading: null,
  returnTo: null,
};

export default React.memo(JoinPaywallContent);
